<template>
	<div class="top-nav">
		<!-- <el-image style="width:50px; height: 50px;border-radius: 50%;" :src="require('../assets/logo.png')" :lazy='true' alt='专利平台' fit="cover"></el-image> -->
		<el-menu background-color='transparent' text-color='#000000' active-text-color='#ffffff' :default-active="activeIndex" :router='true' class="el-menu-top" mode="horizontal">
			<el-menu-item index="/">平台公告</el-menu-item>
			<el-menu-item index="PatentAll">全部专利</el-menu-item>
			<el-menu-item index="Mine">我的专利</el-menu-item>
			<el-image style="width:40px; height: 40px;margin: 0 20px;" :src="require('../assets/toplogo.png')" :lazy='true' alt='专利平台' fit="cover"></el-image>
			<el-menu-item @click="showkefu">客服信息</el-menu-item>
			<el-menu-item index="My">账户信息</el-menu-item>
			<el-menu-item ><a href="http://cponline.cnipa.gov.cn" target="_blank">专利系统</a></el-menu-item>
		</el-menu>
		<div class='top-user'>
			<el-dropdown @command="handleCommand" v-if="userinfo">
				<div class="top-user-down el-dropdown-link">
					<span style="color: #000000;">
						{{userinfo.nickname}}
					</span>
					<el-avatar class='user-avatar' size='small'
						:src="userinfo.avatar"></el-avatar>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command='a' icon="el-icon-setting">个人设置</el-dropdown-item>
					<el-dropdown-item command='b' icon="el-icon-circle-plus-outline">绑定微信</el-dropdown-item>
					<el-dropdown-item command='c' @click.stop="asd" icon="el-icon-remove-outline">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div @click="gologin" class="logintxt" v-else>
				注册/登录
			</div>
		</div>
		<!-- <div style="position: fixed;right:8%;bottom: 30%;z-index:999;">
			<el-image class="kefu-img" @click="showkefu" :src="require('../assets/kefu.png')" fit="fill"></el-image>
		</div> -->
		<!-- 客服绑定弹出框 -->
		<el-dialog title="客服信息" :visible.sync="kefudialogVisible" width="30%">
			<div style="display: flex;align-items: center;justify-content: center;">
				<el-image
				      style="width: 80%; height: 80%;margin: 20px;"
				      :src="kefuimg"
				      fit="cover"></el-image>
			</div>
			<el-alert
			    title="扫二维码添加我为好友"
			    type="info"
			    center
			    :closable='false'>
			  </el-alert>
		</el-dialog>
	</div>
</template>

<script>
	import userApi from '@/api/user'
	export default {
		name: 'TopNav',
		props: {
			activeIndex: String
		},
		data() {
			return {
				userinfo:"",
				kefuimg:'',
				kefudialogVisible:false
			}
		},
		created: function() {
			this.userinfo = JSON.parse(this.$store.state.userinfo);
		},
		methods:{
			showkefu(){
				userApi.getkefu().then(res=>{
					this.kefuimg = res.data.kefuimg;
					this.kefudialogVisible=true;
				})
			},
			handleCommand(command){
				if(command == 'a'){
					if(this.activeIndex != 'My'){
						this.$router.push('My');
					}
				}else if(command == 'b'){
					if(this.activeIndex != 'My'){
						this.$router.push('My');
					}
				}else if(command == 'c'){
					userApi.logout().then(res=>{
						this.$message({
						  message: res.msg,
						  type: 'success'
						});
						this.$store.state.userinfo = null;
						localStorage.removeItem('userinfo');
						this.$store.state.token = null;
						localStorage.removeItem('token');
						this.$router.push('login');
					})
				}
			},
			gologin(){
				this.$router.push('login');
			}
		}
	}
</script>

<style lang="less">
	.logintxt{
		cursor: pointer;
	}
	.kefu-img{
		width: 60px; height: 60px;opacity: .6;cursor: pointer;
		transition: .5s;
		width: 60px;
		cursor: pointer;
		z-index: 99
	}
	
	.kefu-img:hover {
		opacity: 1;
		width: 72px;
		height: 72px;
	}
	.top-nav {
		display: flex;
		align-items: center;
	    background: linear-gradient(#00a0ea, #faf7f8);
		padding: 0 1%;
		.el-menu-top {
			border-bottom: none !important;
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.el-menu-item {
			border-bottom: none !important;
			background-color:transparent !important;
			font-size:18px;
			width: 170px;
			text-align: center;
		}

		.el-menu-top .is-active {
			border-bottom: none !important;
		}
		.top-user {
			margin-left: auto;
			display: flex;
			align-items: center;
			
			.top-user-down{
				display: flex;
				align-items: center;
				color: #aaaaaa;
				.user-avatar {
					margin-left: 10px;
				}
			}
			
		}
	}
</style>